import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/caseclientdetails'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

const GetItem = (fromModule, objectId, isGetSummary, isCheckCaseNo) => {
  return ApiRequest.get(
    `${BaseRoute}?fromModule=${fromModule}&objectId=${objectId}&isGetSummary=${isGetSummary}&isCheckCaseNo=${isCheckCaseNo}`
  )
}

const updateBillingStatus = (caseClientDetailId, data) => {
  return ApiRequest.put(
    `${BaseRoute}/${caseClientDetailId}/billingStatus`,
    data
  )
}

const GetOriginAttachments = (fromModule, objectId) => {
  return ApiRequest.get(
    `${BaseRoute}/getOriginAttachments?fromModule=${fromModule}&objectId=${objectId}`
  )
}

const UpdateIsOnshoreOnly = (data: {
  objectId: string
  fromModule: string
  isOnshoreOnly: boolean | null
}) => {
  return ApiRequest.put(`${BaseRoute}/isOnshoreOnly`, data)
}

const API = {
  ...baseFunctions,
  GetItem,
  GetOriginAttachments,
  updateBillingStatus,
  UpdateIsOnshoreOnly,
}
export default API
